import BX from 'BX';
import {default as Dadata} from './Dadata';
import $ from 'jquery';
import {Alert} from './components/Bootstrap/Alert';
import Vue from 'vue';
import {getFullNameSuggestions} from './api/dadata';

/** @typedef { import('./Autocomplete').AutocompleteDataset } AutocompleteDataset */
/** @typedef { import('./api/dadata').NameSuggestion } NameSuggestion */

const AlertComponent = Vue.extend({
    data: () => ({
        message: '',
    }),
    render(h) {
        return (this.message) ? (
            <Alert type="danger" class="mt-1">
                {this.message}
            </Alert>
        ) : null;
    }
});

class DadataName extends Dadata {
    /**
     *
     * @param {HTMLElement} target
     */
    constructor(target) {
        super(target);

        const alert = new AlertComponent;

        alert.$mount();
        $(this.dadataNode).closest('.input-block')[0].append(alert.$el);

        if (this.dadataNode.value) {
            // TODO: clean up this mess
            const query = this.dadataNode.value.trim();

            getFullNameSuggestions(query).then(suggestions => {
                const appropriateSuggestion = findAppropriateSuggestion(suggestions, query);

                if (appropriateSuggestion) {
                    const alertMessage = getAlertMessage(appropriateSuggestion);

                    if (alertMessage) {
                        alert.message = alertMessage;
                        this.dadataNode.setCustomValidity(alertMessage);
                    }
                } else {
                    const message = 'Пожалуйста, уточните ваше ФИО';

                    this.dadataNode.placeholder = this.dadataNode.value;
                    this.dadataNode.value = '';
                    alert.message = message;
                    this.dadataNode.setCustomValidity(message);
                }
            });
        }

        this.initializeAutocomplete()
            .on('autocomplete:selected', (event, suggestion) => {
                const alertMessage = getAlertMessage(suggestion);

                if (alertMessage) {
                    alert.message = alertMessage;
                    this.dadataNode.setCustomValidity(alertMessage);
                } else if (alert.message) {
                    alert.message = '';
                    this.dadataNode.setCustomValidity('');
                }
            });
    }

    getSource() {
        const source = Object.assign({}, this.sourceOptions, {
            source: (query, cb) => getFullNameSuggestions(query).then(cb),
            displayKey: ({data}) => getFullName(data),
            templates: {
                suggestion: ({data}) => document.createTextNode(getFullName(data))
            }
        });

        return source;
    }
}

/**
 *
 * @param {NameSuggestion} param0
 */
function getAlertMessage({data: {name, surname}}) {
    /** @type {string[]} */
    const required = [];

    if (!name)
        required.push('имя');

    if (!surname)
        required.push('фамилию');

    if (required.length) {
        let message = 'Необходимо ввести ';

        message += required.join(' и ');

        return message;
    }
}

/**
 *
 * @param {NameSuggestion[]} array
 * @param {string} value
 */
function findAppropriateSuggestion(array, value) {
    return array.find(item => item.value === value);
}

/**
 *
 * @param {NameSuggestion} param0
 */
function getFullName({data: {name, surname, patronymic}}) {
    /** @type {string[]} */
    const fullname = [];

    if (surname)
        fullname.push(surname);

    if (name)
        fullname.push(name);

    if (patronymic)
        fullname.push(patronymic);

    return fullname.join(' ');
}

export default DadataName;

BX.namespace('DadataName');

BX.DadataName.init = function () {
    document
        .querySelectorAll('[is="dadata-name"]')
        .forEach(elem => {
            elem.removeAttribute('is');
            new DadataName(elem);
        });
}
